import { exitImpersonation, isImpersonating } from '../operational-model/Admin/adminApi';

const ImpersonationBanner = () => {
  if (!isImpersonating()) return null;

  const adminName = localStorage.getItem('IMPERSONATION_ADMIN_NAME') || 'Super Admin';

  return (
    <div className="impersonation-banner">
      Viewing as pump user — logged in as super admin ({adminName}).
      <button type="button" className="btn btn-sm btn-light" onClick={exitImpersonation}>
        Exit & return to admin
      </button>
    </div>
  );
};

export default ImpersonationBanner;
